import { CarouselProps } from '@/types'
import React, { useEffect, useState } from 'react'
import ErrorBoundary from '../Errorhandler'
import './index.scss'

const Carousel: React.FC<CarouselProps> = ({ imgSrc, height = 500, maxHeight = 500 }) => {
  const [imageFadeClass, setImageFadeClass] = useState('')
  const [errorState, setErrorState] = useState(false)

  const handleImageError = () => {
    setErrorState(true)
  }

  useEffect(() => {
    setErrorState(false)
    setImageFadeClass('carousel-image-fadein')
    setTimeout(() => {
      setImageFadeClass('carousel-image-fadeout')
    }, 4000)
  }, [imgSrc])

  const containerStyle = {
    height: typeof height === 'number' ? `${height}px` : height,
    maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,
  }

  return (
    <ErrorBoundary>
      <div className="carousel-container" style={containerStyle}>
        {errorState && (
          <div className={`loading-state ${imageFadeClass}`}>
            Loading...
            <div className="loading-box"></div>
          </div>
        )}

        {!errorState && (
          <img
            src={imgSrc}
            alt="life is good"
            className={`carousel-image ${imageFadeClass}`}
            onError={handleImageError}
          />
        )}
      </div>
    </ErrorBoundary>
  )
}

export default Carousel
